<script setup lang="ts">
defineProps<{
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  variant?: 'h1' | 'h2' | 'h3' | 'body' | 'caption';
}>();
</script>

<template>
  <component
    :is="as || 'p'"
    :class="[
      variant === 'h1' ? 'babel-text-h1' :
      variant === 'h2' ? 'babel-text-h2' :
      variant === 'h3' ? 'babel-text-h3' :
      variant === 'caption' ? 'babel-text-caption' :
      'babel-text-body'
    ]"
  >
    <slot />
  </component>
</template>
